<div id="layoutAuthentication">
  <div id="layoutAuthentication_content">
    <main>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <div class="card shadow-lg border-0 rounded-lg mt-5">
              <div class="card-header">
                <h3 class="text-center font-weight-light my-4">PROPER ERP</h3>
              </div>
              <div class="card-body">
                <form>
                  <div class="form-group">
                    <label class="small mb-1" for="inputEmailAddress"
                      >Nombre de usuario</label
                    >
                    <input
                      [(ngModel)]="username"
                      class="form-control py-4"
                      id="inputUsername"
                      name="username"
                      type="text"
                      placeholder="Introducir el nombre de usuario"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label class="small mb-1" for="inputPassword"
                      >Contraseña</label
                    >
                    <input
                      [(ngModel)]="password"
                      class="form-control py-4"
                      id="inputPassword"
                      name="password"
                      type="password"
                      placeholder="Introducir la contraseña"
                      required
                    />
                  </div>
                  <!-- <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" id="rememberPasswordCheck"
                                                type="checkbox" />
                                            <label class="custom-control-label" for="rememberPasswordCheck">Remember
                                                password</label>
                                        </div>
                                    </div> -->
                  <div
                    class="form-group d-flex align-items-center justify-content-between mt-4 mb-0"
                  >
                    <a class="small" href="">¿Olvidaste tu contraseña?</a>
                    <button
                      class="btn btn-primary text-white"
                      type="button"
                      (click)="login()"
                    >
                      Ingresar
                    </button>
                  </div>
                </form>
              </div>
              <!-- <div class="card-footer text-center">
                                <div class="small"><a href="register.html">Need an account? Sign up!</a></div>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <div id="layoutAuthentication_footer">
    <footer class="py-4 bg-light mt-auto">
      <div class="container-fluid">
        <div class="d-flex align-items-center justify-content-between small">
          <div class="text-muted">Copyright &copy; Your Website 2020</div>
          <div>
            <a href="#">Privacy Policy</a>
            &middot;
            <a href="#">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
